import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAlphaNumericOnly]'
})
export class AlphaNumericOnlyDirective {

  private el: ElementRef;

  constructor(el: ElementRef) {
    this.el = el;
  }

  // Listen for the input event to also handle copy and paste.
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Use NgControl patchValue to prevent the issue on validation
    //this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFF0-9a-zA-Z\s]/g, '');
  }
}
